import React, { FC, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
import moment from "moment";

import ChartRangeSelector from "./ChartRangeSelector";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import { PeriodIndexTypes, PeriodTypesArray } from "../../services/enums";
import HighChartsService from "../../services/highcharts.service";
import { IResultResponse } from "../../models/response/result.model";
import { IQuotes } from "../../models/quotes.model";

const InstrumentHistoricalChart: FC = () => {
  const [periodIndex, setPeriodIndex] = useState(PeriodIndexTypes["1m"]);

  const { id } = useParams();

  const { fetchedData, loading } = useHttpGet<IResultResponse<IQuotes[]>>(
    `${APIRoutes.QUOTES_FOR_INSTRUMENT}/${id}/${PeriodTypesArray[periodIndex]}`,
    {
      dependencies: [periodIndex],
      condition: !!id,
    }
  );

  const getOptions = (data: IQuotes[] = []) => {
    return {
      ...HighChartsService.baseSettings({
        series: [
          {
            name: data[0]?.instrument?.name,
            data: CommonService.sortByDate(data, "settlementDate")?.map(
              (el: IQuotes) => [
                moment(el?.settlementDate).unix() * 1000,
                el?.adjClose,
              ]
            ),
          },
        ],
      }),
    };
  };

  return (
    <Spin spinning={loading}>
      <ChartRangeSelector
        periodIndex={periodIndex}
        setPeriodIndex={setPeriodIndex}
      />
      <HighchartsReact
        constructorType={"stockChart"}
        highcharts={Highcharts}
        options={getOptions(fetchedData?.result)}
      />
    </Spin>
  );
};

export default InstrumentHistoricalChart;
